import { PAGE_FONT_SX } from 'src/theme/universe/pageFont';
import {
  ghostButtonSx,
  iconButtonSx,
  secondaryButtonSx
} from 'src/theme/universe/buttonSx';
import { menuPaperSx } from 'src/theme/universe/surfaceSx';

export const notificationContentSx = (theme) => ({
  ...PAGE_FONT_SX,
  minWidth: 0,
  width: '100%',
  '& .MuiButton-root': ghostButtonSx(theme, 'small'),
  '& .MuiButton-outlined': secondaryButtonSx(theme, 'small'),
  '& .MuiIconButton-root': iconButtonSx(theme)
});

export const notificationPaperSx = (theme) => ({
  ...menuPaperSx(theme),
  p: 0,
  width: 420,
  maxWidth: 'calc(100vw - 32px)'
});
